import { Component, Input, ElementRef, Output, EventEmitter, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BreadcrumbModel, HtmlBase, QueovalItem, BObjectModel, PropertyData, DynamicGroup, PropertyGroup, BreadDik, ConfigKey, ModeBo, eAppContext } from '../../models';
import { isEmptyStr } from '../../utilities';
import { BreadcrumbService, CoreService, HttpService, StoreService } from '../../services';
import { ToastService } from '../../toast';
import { DialogService } from '../../dialog';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-dynamictag',
  templateUrl: './dynamictag.component.html',
  styleUrls: ['./dynamictag.component.css']
})

export class DynamictagComponent implements AfterViewInit {

  public model: BObjectModel;
  public breadcrump: BreadcrumbModel;
  public modeBoEnum = ModeBo;
  public modeBo: ModeBo = ModeBo.Edit;
  public templateName: string = '';
  @Input('ModeBo') set Mode(value: ModeBo) { this.modeBo = value; };
  @Input('Model') set Model(value: BObjectModel) { this.model = value; }
  @Input('item') item: PropertyData;
  @Input('title') title: string;
  @Input('parent') parent: ElementRef;
  @Output() sendBreadcrumb: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>(true);
  @Output() itemChange: EventEmitter<PropertyData> = new EventEmitter<PropertyData>(false);

  // #region templates to pass to container dinamically

  //@ViewChild('zoom', { static: false }) zoom: ElementRef;
  //@ViewChild('checkbox', { static: false }) checkbox: ElementRef;
  //@ViewChild('text', { static: false }) text: ElementRef;
  //@ViewChild('select', { static: false }) select: ElementRef;
  //@ViewChild('textarea', { static: false }) textarea: ElementRef;
  //@ViewChild('image', { static: false }) image: ElementRef;
  //@ViewChild('datepicker', { static: false }) datepicker: ElementRef;
  //@ViewChild('postalcode', { static: false }) postalcode: ElementRef;
  //@ViewChild('ackkey', { static: false }) ackkey: ElementRef;
  //@ViewChild('timer', { static: false }) timer: ElementRef;
  //@ViewChild('checkcom', { static: false }) checkcom: ElementRef;
  //@ViewChild('searchselect', { static: false }) searchselect: ElementRef;
  //@ViewChild('couple', { static: false }) couple: ElementRef;
  //@ViewChild('aspx', { static: false }) aspx: ElementRef;
  //@ViewChild('accessDocAndFile', { static: false }) accessDocAndFile: ElementRef;
  //@ViewChild('email', { static: false }) email: ElementRef;
  //@ViewChild('imageselect', { static: false }) imageselect: ElementRef;
  //@ViewChild('texthistorique', { static: false }) texthistorique: ElementRef;
  //@ViewChild('cabinet', { static: false }) cabinet: ElementRef;
  //@ViewChild('insee', { static: false }) insee: ElementRef;
  //@ViewChild('videoZoom', { static: false }) videoZoom: ElementRef;
  //@ViewChild('elearningChapters', { static: false }) elearningChapters: ElementRef;
  //@ViewChild('textEditor', { static: false }) textEditor: ElementRef;
  //@ViewChild('checkboxlistgroup', { static: false }) checkboxlistgroup: ElementRef;
  //@ViewChild('socialNetwork', { static: false }) socialNetwork: ElementRef;
  //@ViewChild('numering', { static: false }) numering: ElementRef;
  //@ViewChild('searchAgGrid', { static: false }) searchAgGrid: ElementRef;

  // #endregion

  constructor(
    private indParam: CoreService,
    private httpservice: HttpService,
    private http: HttpClient,
    private storeservice: StoreService,
    private dialogservice: DialogService,
    private toastservice: ToastService,
    private cd: ChangeDetectorRef,
    private breadCrumbService: BreadcrumbService,
  ) { }

  //#region html display functions

  //IsComplex(item: PropertyData): boolean {
  //  return item.Mode === 'COMPLEX';
  //}
  IsVisible(item: PropertyData): boolean {
    return item.MainLabel.Visible && item.MainElementList[0].Mask !== 'DATEFIN';
    //return this.IsComplex(item)
    //  ? item.MainLabel.Visible && item.MainElementList[0].Mask !== 'DATEFIN'
    //  : item.MainLabel.Visible; 
  }
  //GetTemplate(item: PropertyData): ElementRef | null {
  //  return this.IsComplex(item) ? this.GetTemplateComplex(item) : this.GetTemplateSimple(item);
  //}
  //private GetTemplateSimple(item: PropertyData): ElementRef | null {
  //  if (!item.MainElementList || item.MainElementList.length === 0)
  //    return null;
  //  else {
  //    switch (item.MainElementList[0].TagName.toUpperCase()) {
  //      case 'CHECKBOX': return this.checkbox;
  //      case 'SELECT': case 'SELECTMOD': return this.select;
  //      case 'TEXTAREA': return this.textarea;
  //      case 'IMAGE': return this.image;
  //      case 'DATEPICKER': return this.datepicker;
  //      case 'ACKKEY': return this.ackkey;
  //      case 'INPUT': return item.QueovalCode === 'TXTZOOM' ? this.zoom : this.text;

  //      default: return null;
  //    }
  //  }
  //}
  private GetTemplate(item: PropertyData): void {
    if ((!item.MainElementList || item.MainElementList.length === 0) && !item.QueovalCode) {
      item.MainElementList = [new HtmlBase('', 'Propriété non implétée')];
      this.templateName = 'text';
      return;
    }
    else {
      switch (item.QueovalCode.toUpperCase()) {
        case 'LISTGRPCNX':
          // liste des groupes utilisateur pour affecter directement le collaborateur (il faut l'utiliser sur une personne physique)
          this.templateName = 'checkboxlistgroup';
          return;
        case 'CPVILLE':
          this.templateName = 'postalcode';
          return;
        case 'HEMINSEC':
          this.templateName = 'timer';
          return;
        //case 'CHECKCOM':
        //  this.templateName = 'checkcom';
        //  return;
        case 'COMBOCPF':
        case 'COMBOCLP':
        case 'COMBOCLI':
        case 'COMBOCON':
        case 'COMBOCLF':
          this.templateName = 'searchselect';
          return;
        case 'PLMINMAX':
        case 'TXTCPL':
          this.templateName = 'couple';
          return;
        case 'CODUNIC':
        case 'EXTIDCOL':
        case 'EXTIDREL':
        case 'LISTE':
        case 'EXTUSER':
        case 'EXTCOL':
        case 'CTI':
        case 'SMS':
        case 'EXPLO':
        case 'EXTIDBO':
        case 'EXTGRP':
        case 'TRADUC':
        case 'EXTTABLE':
          this.templateName = 'aspx';
          return;
        case 'ACESPORT':
          this.templateName = 'acesport';
          return;
        case 'DOCUDOWN':
        case 'RPT_FACT':
        case 'DOCU':
        case 'PATH':
        case 'DOCUWEB':
          this.templateName = 'accessDocAndFile';
          return;
        case 'EMAIL':
          this.templateName = 'email';
          return;
        case 'COMBOIMG':
          this.templateName = 'imageselect';
          return;
        case 'TEXTHIST':
        case 'TXTHISMU':
          this.templateName = 'texthistorique';
          return;
        case 'RADIOBUT':
          if (item.MainElementList[0].Mask === 'CABINET')
            this.templateName = 'cabinet'
          return;
        case 'SITESCOM':
          this.templateName = 'insee';
          return;
        case 'URLZOOMVIDEO':
          this.templateName = 'videoZoom';
          return;
        case 'CHAPITEL':
          this.templateName = 'elearningChapters';
          return;
        case 'TEXTEDITOR':
          this.templateName = 'textEditor';
          return;
        case 'SITSOCIO':
          this.templateName = 'socialNetwork';
          return;
        case 'NUMERBTN':
        case 'CPCLIENT':
        case 'NUMERING':
          this.templateName = 'numering';
          return;
        case 'OGDPC':
          this.templateName = 'searchAgGrid';
          return;
        case 'TXTZOOM':
          this.templateName = 'zoom';
          return;
        case 'RUM_SEPA':
          this.templateName = 'rumSepa';
          return;
        default:
          if (!item.MainElementList || item.MainElementList.length === 0) {
            item.MainElementList = [new HtmlBase('', 'Propriété non implétée')];
            this.templateName = 'text';
            return;
          }
          else {
            switch (item.MainElementList[0].TagName.toUpperCase()) {
              case 'CHECKBOX':
                this.templateName = 'checkbox';
                return;
              case 'SELECT':
              case 'SELECTMOD':
                this.templateName = 'select';
                return;
              case 'TEXTAREA':
                this.templateName = 'textarea';
                return;
              case 'IMAGE':
                this.templateName = 'image';
                return;
              case 'DATEPICKER':
              case 'DATEHOURPICKER':
              case 'CYCLEEL':
              case 'CHECKDAT':
                this.templateName = 'datepicker';
                return;
              case 'ACKKEY':
                this.templateName = 'ackkey';
                return;
              case 'INPUT':
                this.templateName = 'text';
                return;
              default:
                this.templateName = 'text';
                return;
            }
          }
      }
    }
  }
  getId(item: PropertyData): string {
    return item.MainElementList && item.MainElementList.length > 0 ? item.MainElementList[0].ID : '';
  }
  setClass(item: PropertyData, index: number = 0): string {
    if (item.MainElementList[index].Required) {
      //alert(item.MainElementList[index].InValid);
      const t: boolean | undefined = item.MainElementList[index].InValid;
    }
    if (item.MainElementList[index].Disabled)
      return 'q-bo-disabled';
    if (item.MainElementList[index].InValid)
      return 'q-bo-novalid';
    if (item.MainElementList[index].Required)
      return 'q-bo-required';
    return '';
  }
  isDisabled(item: PropertyData): boolean {
    //////return (this.view && this.view === 'read') ? true : item.MainElementList[0].Disabled;
    return item.MainElementList[0].Disabled;
  }

  //#endregion

  ngAfterViewInit(): void {
    this.GetTemplate(this.item);
    // in order to avoid the ExpressionChangedAfterItHasBeenCheckedError when we load "<ng-container [ngTemplateOutlet]="
    // due to the "change detection cycle" that Angular performs for each component in the application's tree of components
    // (NB - it happens only in development environment)
    // we injected in the class contructor the ChangeDetectorRef class
    // this force another "change detection cycle" for the parent dynamictag.component to detect chamges in children components loaded in the ng-container template
    this.cd.detectChanges();
  }


  // action associated to the label of each element
  public methodLabel(e: string): void { }

  // action associated to the input check element
  public checkChange(e: any, elem: PropertyData): void {
    const check: boolean = e.target.checked;
    const id: string = e.target.id;
    const tag: HtmlBase[] = elem.MainElementList.filter((element: HtmlBase): boolean => element.ID === id);
    if (tag && tag.length === 1) {
      tag[0].Value = check ? '1' : '0';
    }
  }

  // action associated to the select element
  public selectChange(selectedValue: string, selectItem: PropertyData): void {
    if (selectItem) {
      for (const item of selectItem.MainElementList[0].SelectOptionsList) {
        item.Selected = item.Value === selectedValue;
      }
    }
  }

  // action associated to the searchselect/aspx/accessDocxAndFile elements
  public navigFromChildTag(element: HtmlBase): void {
    this.navig(element);
  }


  public navigReseauxSociaux(element: HtmlBase): void {
    window.open(element.OnClick, '_blank');
  }


  // action associated to the zoom/inputWithButton/selectWithButton elements
  public navig(element: HtmlBase, input?: PropertyData): void {
    const switchValue = element && element.TypeModal ? element.TypeModal : '';
    switch (switchValue.toUpperCase()) {
      case 'URL':
        if (input !== undefined) {
          switch (input.QueovalCode) {
            case 'SITESCOM':
              element.OnClick = `${element.OnClick}${element.Value}`;
              break;
            case 'SITE':
              element.OnClick = input.MainElementList[0].Value;
              if (!isEmptyStr(element.OnClick)) {
                if (element.OnClick.substring(0, 4) !== 'http') {
                  if (element.OnClick.substring(0, 3) !== 'www') {
                    element.OnClick = `http://www.${element.OnClick}`;
                  } else {
                    element.OnClick = `http://${element.OnClick}`;
                  }
                }
                if (element.OnClick.substring(element.OnClick.length - 3, element.OnClick.length) !== 'com') {
                  if (element.OnClick.substring(element.OnClick.length - 2, element.OnClick.length) !== 'fr') {
                    element.OnClick += '.com';
                  }
                }
              } else {
                element.OnClick = 'https://www.google.com';
              }
              input.MainElementList[0].Value = element.OnClick;
              break;
          }
        }

        window.open(element.OnClick, '_blank');
        break;
      case 'COMPONENT':
        let params: string = '';
        if (element.OnClickParams) {
          params = Array.from((element.OnClickParams), parameters => `${parameters.Text ? parameters.Text + '=' : ''}${parameters.Value}`).join('&');
        }
        const p: Array<BreadDik> = new Array<BreadDik>();
        p.push(new BreadDik('params', params));
        const param: { params: Array<BreadDik>, model: BObjectModel } = { params: p, model: this.model };

        let lstOnClick: string[] = [''];
        if (element.OnClick) {
          lstOnClick = element.OnClick.split('|');
        }
        const link: string = lstOnClick[0]
        const mode: string = lstOnClick.length > 1 ? lstOnClick[1] : 'add';
        const strIndex: string = lstOnClick.length > 2 ? lstOnClick[2] : '-1';
        let index: number = -1;
        if (mode === 'replaceNode') {
          try {
            index = parseInt(strIndex);
            if (isNaN(index)) index = -1;
          } catch (ex) {
            index = -1;
          }
        }
        let route: string = '';
        switch (link) {
          case 'facturation/mode-facturation':
            route = '/view/facturation/mode-facturation';
            break;
          case 'zoom':
            switch (this.indParam.AppParams.context) {
              case eAppContext.QUEOVAL:
                route = `view/agenda-v3/agendazoom`;
                break;
              case eAppContext.EXTRANET:
                route = `webform/agenda-v3/extranet-agendazoom`;
                break;
            }
            break;
          default:
            break;
        }
        let breadCrumbItem: BreadcrumbModel;
        if (route) {
          breadCrumbItem = new BreadcrumbModel(mode, route, param, element.ToolTip, true);
          this.breadCrumbService.call(breadCrumbItem, index);
        } else {
          breadCrumbItem = new BreadcrumbModel('', element.OnClick, param, element.ToolTip, true);
        }
        this.sendBreadcrumb.emit(breadCrumbItem);
        break;
      case 'ASPX':
        window.open(element.OnClick, '_blank');
        break;
    }
  }

  // action associated to the zoom element
  public copyInClipboard(text: string): void {
    const tempInput: any = document.createElement('input');
    tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    this.toastservice.showInfoToast('lien copié !');
  }

  //#region actions associated to image element

  public onChangeImage(e: any, input: PropertyData): void {   
    if (e.target.files && e.target.files.length > 0)
      this.uploadFile(input, e.target.files[0]);
    else
      this.toastservice.showAlertToast('unable to load the file');
    e.target.value = '';
  }

  public deleteFile(input: PropertyData): void {
    this.dialogservice.showSplash(true);
    this.model.Mode = 'DELETEFILE';
    const clientData: DynamicGroup = new DynamicGroup;
    let htmlbase: HtmlBase = new HtmlBase(input.MainElementList[0].ID, 'IMAGE');
    htmlbase = input.MainElementList[0];
    clientData.Input = htmlbase;
    this.model.ClientData = clientData;
    this.httpservice.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, this.model).subscribe((result: BObjectModel): void => {
      this.model = result;
      this.model.Body.SelectedGroupsList.forEach((element: PropertyGroup): void => {
        element.DataList.forEach((item: PropertyData): void => {
          if (item.MainElementList[0].ID === input.MainElementList[0].ID) {
            input.MainElementList[0].Src = item.MainElementList[0].Src;
            input.MainElementList[0].Value = '';
          }
          if (item.MainElementList[0].ID === 'PhotoPER') {
            this.storeservice.sendImageProfil('');
          }
        });
      });
      this.dialogservice.showSplash(false);
      //this.toastservice.showSuccessToast(result.Alert);
    }
    );
  }

  public OnItemChange(item: PropertyData): void {
    this.itemChange.emit(item);
  }
  private uploadFile(input: PropertyData, file: File): void {
    if (!file)
      return;

    const filesize: number = file.size;
    // Taille max d'une image dans un BO : 3Mo
    if (filesize > 3000000 || filesize === 0) {
      this.dialogservice.showSplash(false);
      this.dialogservice.showAlert(`${this.indParam.getTrad('ext_uploadSize')}`);
      return;
    }

    this.dialogservice.showSplash(true);

    const ext: string = file.name.split('.')[file.name.split('.').length - 1];

    // 1) we pass to the webstreamAPI the parameter 'saveas' with a unique key
    // 2) the webstreamAPI rename the file with a time stamp stock the file in the proper folder
    const timestamp: string = `${Math.floor(Math.random() * Math.floor(999))}${Math.floor(Date.now() / 1000)}`;
    const currentValue: string = input.MainElementList[0].Value === null ? '' : input.MainElementList[0].Value;
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('mode', 'BODISPLAY');
    formData.append('timestampname', `${timestamp}.${ext}`);
    formData.append('currentValue', currentValue);
    formData.append('token', this.indParam.AppParams.token);

    const streamHttp: string = this.indParam.getConfigKey(ConfigKey.STREAM_HTTP);

    let headers: any = { headers: { Queoval: this.indParam.AppParams.token } };

    //const call1: Observable<StreamExtranetModel> = this.http.get<StreamExtranetModel>(`${streamHttp}api/Stream/BO/PREDATA/0`, headers);
    this.http.post(`${streamHttp}api/StreamUpload`, formData, { responseType: 'arraybuffer' as 'arraybuffer' }).subscribe((results: any): void => {
      const fileName: string | null = `${timestamp}.${ext}`;
      const httpPath: string | null = `${this.indParam.getConfigKey(ConfigKey.IMGHTTP)}/Images/${this.indParam.AppParams.dbname}/${fileName}`;  //`${results[0].StreamUpload.FullPathResult}/${fileName}`;

      if (httpPath && fileName) {

        input.MainElementList[0].Src = httpPath;
        input.MainElementList[0].Value = fileName;

        if (this.model.IdDonneeFils && this.model.IdDonneeFils !== '0') {
          const clientData: DynamicGroup = new DynamicGroup;
          clientData.Input = input.MainElementList[0];
          this.model.ClientData = clientData;
          this.model.Mode = 'UPLOADIMAGE';

          this.httpservice.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, this.model).subscribe((result: BObjectModel): void => {
            //this.toastservice.showSuccessToast(result.Alert);
            this.dialogservice.showSplash(false);
          }
          );
        }
        else this.dialogservice.showSplash(false);


      } else {
        this.dialogservice.showSplash(false);
      }
    }, (error: Error): void => {
      console.error(JSON.stringify(error));
      this.dialogservice.showSplash(false);
    });
  }

  //#endregion
}
